module.exports = __webpack_public_path__ + "img/mic.58e127e9.svg";